import axios from 'axios';
import roomCalendar from "./room-calendar";
import roomDate from "./room-date";
import roomGames from "./room-games";
import roomPlayersChange from "./room-player-change";
import roomPlayersRange from "./room-players-range";
import roomTimeChange from "./room-time-change";
import roomTimeSlot from "./room-time-slot";
import {roomModal} from "./room-modal";
import roomBooking from './room-booking';

declare let booking_object: any;

export default class roomInit {

    // Keep only the selectors as class properties
    private el_rooms: string = '#room-games-filter';
    private el_time_slot: string = '#field-room-time-slot';
    private el_players: string = '#field-room-players';
    private el_games_container: string = '#games-container';

    async init(){ 

        const room = document.querySelector(this.el_rooms) as HTMLElement | null;
        if (!room) return;

        const room_id = room.dataset.room as string;
        if (!room_id) return;

        // Create a single instance for games module to be used in both try and catch
        const modRoomGames = new roomGames();

        try {

            // --- Create module instances as LOCAL CONSTANTS ---
            // This is the key fix to ensure stable references for the handlers.
            const modBookCalendar = roomCalendar('#field-room-book-calendar');
            const modTimeSlot = new roomTimeSlot();
            const modPlayersRange = new roomPlayersRange();
            
            // Safety check for the calendar
            if (!modBookCalendar) {
                throw new Error("Calendar module failed to initialize.");
            }
            
            // --- PHASE 0: FETCH INITIAL BOOTSTRAP DATA ---
            modRoomGames.showPreloader(this.el_games_container);

            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const dateNow = now.toISOString().slice(0, 10);
            
            const response = await axios.post(booking_object.rest_urls.get_init_games, {
                room_id: room_id,
                date: dateNow, 
                time: `${hours}:${minutes}`
            });

            const initialData = response.data.data;

            // --- PHASE 1: INITIALIZE AND POPULATE CONTROLS ---
            modTimeSlot.initialize(this.el_time_slot);
            modPlayersRange.initialize(this.el_players);
            
            if (!initialData || !initialData.resolved_date) {
                
                modRoomGames.showError(this.el_games_container, 'The room is currently unavailable. Please try again later.');
                return;

            }

            if(modBookCalendar){
                
                // Manually parse the date string to create a reliable Date object, avoiding timezone issues.
                const dateParts = initialData.resolved_date.split('-').map((part: string) => parseInt(part, 10));
                
                // The month is 0-indexed in JavaScript's Date constructor (0=Jan, 1=Feb, etc.)
                const safeDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

                // Now, pass the reliable Date object to the setDate method
                modBookCalendar.setDate(safeDate);

                now.setHours(0, 0, 0, 0);

                // If the new date is in the future, lock past dates by updating the minDate option
                if(safeDate.getTime() > now.getTime()){
                    
                    modBookCalendar.setOptions({
                        minDate: safeDate
                    });

                }

            }
            
            modTimeSlot.populate(initialData.time_slots);
            modPlayersRange.populate(initialData.players_range);
            
            if (initialData.initial_games) {
                modRoomGames.renderGames(initialData.initial_games, this.el_games_container);
            } else {
                modRoomGames.showError(this.el_games_container, 'Select fields to view games.');
            }

            // --- PHASE 2: SET UP EVENT HANDLERS ---
            // We pass the local, guaranteed-to-be-correct instances to the handlers.
            
            const dateChange = new roomDate({
                roomId: room_id,
                calendarModule: modBookCalendar,
                timeSlotModule: modTimeSlot,
                gamesModule: modRoomGames,
                timeSlotSelector: this.el_time_slot,
                playersSelector: this.el_players
            });
            dateChange.initialize();

            const timeSlotChangeHandler = new roomTimeChange({
                roomId: room_id,
                calendarModule: modBookCalendar,
                gamesModule: modRoomGames,
                playersSelector: this.el_players,
                timeSlotControl: modTimeSlot.control
            });
            timeSlotChangeHandler.initialize();

            const playersChangeHandler = new roomPlayersChange({
                roomId: room_id,
                calendarModule: modBookCalendar,
                gamesModule: modRoomGames,
                timeSlotSelector: this.el_time_slot,
                playersControl: modPlayersRange.control
            });
            playersChangeHandler.initialize();

            const roomModalManager = new roomModal({
                fetchUrl: booking_object.rest_urls.get_room_game_data,
                triggerClass: 'btn-room-booking-info'
            });
            roomModalManager.init();

            const bookingHandler = new roomBooking({
                roomId: room_id,
                calendarModule: modBookCalendar,
                timeSlotModule: modTimeSlot,
                playersRangeModule: modPlayersRange
            });
            bookingHandler.initialize();

        }catch (error){
            
            console.error("A critical error occurred during initialization:", error);
            modRoomGames.showError(this.el_games_container, 'Impossibile caricare la pagina. Si è verificato un errore.');

        }

    }

}